import { z } from 'zod'

export const designSystemLibrarySearchSchema = z.object({
  component: z.string().optional(),
  foundation: z.string().optional(),
  query: z.string().optional(),
})

export type DesignSystemLibrarySearch = z.infer<
  typeof designSystemLibrarySearchSchema
>
